import { IAvaliarTreinamentoUseCase } from "../../../presentation/useCases/create/avaliar_treinamento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

import CommonConstants from "../../../../../common/constants";

/**
 * AvaliarTreinamentoUseCase
 */

export class AvaliarTreinamentoUseCase implements IAvaliarTreinamentoUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async avaliarTreinamento(
    idFuncionarioTreinamento: number | null,
    eficaz: number,
    avaliador: string | null,
    dataAvaliacao: Date | null,
    evidenciaObjetiva: string | null,
    originScreen?: number,
  ): Promise<void> {
    await this.repository.avaliarTreinamento(
      idFuncionarioTreinamento,
      null,
      eficaz,
      avaliador,
      dataAvaliacao,
      evidenciaObjetiva,
      originScreen ?? CommonConstants.avaliarTreinamentoScreen.FuncionarioCadastro,
    );
  }

  async avaliarTreinamentoLote(
    idFuncionarioTreinamentoLote: number[],
    eficaz: number,
    avaliador: string | null,
    dataAvaliacao: Date | null,
    evidenciaObjetiva: string | null,
    originScreen?: number,
  ): Promise<void> {
    await this.repository.avaliarTreinamento(
      null,
      idFuncionarioTreinamentoLote,
      eficaz,
      avaliador,
      dataAvaliacao,
      evidenciaObjetiva,
      originScreen ?? CommonConstants.avaliarTreinamentoScreen.FuncionarioCadastro,
    );
  }
}